import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseTypographyComponent } from '../base-typography.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-body-xs',
  template: '<span [ngClass]="ngClass"><ng-content></ng-content></span>',
  styleUrls: ['./body-extra-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class BodyExtraSmallComponent extends BaseTypographyComponent {}
